// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import { HTMLAttributes, forwardRef } from 'react'

import { FilterValue } from '../../../__generated__/graphql/catalog/graphql'
import { useGenerateFilterSelectionPath } from '../../../brunswick/components/pages/Collection/sections/CollectionGridSection/hooks/useGenerateFilterSelectionPath'
import { useCollectionFilterQueryParamsContext } from '../../../brunswick/containers/CollectionFilterQueryParamsContext'
import { useHeapAttributes } from '../../../containers/HeapAttributesContainer'
import { trackEvent } from '../../../lib/analytics'

import * as Styles from './styles'

export type CheckboxFilterItemProps = {
  /* The unique key of the filter group. */
  filterKey: string
  /* The filter value object. */
  filterValue: FilterValue
  /* Render the menu item as an anchor instead of an interactive button. */
  asLink?: boolean
  /* Whether the checkbox should display it's hover state. */
  hover?: boolean
} & HTMLAttributes<HTMLInputElement>

/* A basic checkbox menu item to display within a list of filters. */
export const CheckboxFilterItem = forwardRef<HTMLInputElement, CheckboxFilterItemProps>(
  function CheckboxFilterItem({ filterValue, filterKey, asLink, hover, onChange, ...rest }, ref) {
    const analyticsContext = useHeapAttributes()
    const { selectedFilters, toggleSelectedFilter } = useCollectionFilterQueryParamsContext()

    const generateFilterSelectionPath = useGenerateFilterSelectionPath()

    const selectedValues = selectedFilters[filterKey]
    const key = `${filterKey}:${filterValue.value}`
    const path = generateFilterSelectionPath(filterKey, filterValue.value)

    const handleChange = (value: string) => {
      if (asLink) return // When filter selectors are rendered as links, the page navigation will handle updating the query params.
      toggleSelectedFilter(filterKey, value)
    }

    const selector = (
      <Styles.OptionCheckbox
        ref={ref}
        {...trackEvent({
          customAttributes: {
            'data-heap-filter-type': 'dropdown',
          },
          category: `${analyticsContext.category} filters`,
          action: 'change',
          label: filterKey,
          value: filterValue.value,
        })}
        key={key}
        // Optimistically display selected state while network request resolves:
        checked={filterValue.state === 'SELECTED' || !!selectedValues?.includes(filterValue.value)}
        disabled={filterValue.state === 'DISABLED'}
        hover={hover}
        type='checkbox'
        value={filterValue.value}
        onChange={evt => {
          handleChange(filterValue.value)
          onChange?.(evt)
        }}
        {...rest}
      >
        <Styles.Label>{filterValue.value}</Styles.Label>
      </Styles.OptionCheckbox>
    )
    return asLink ? (
      <Link href={path} shallow={true} tabIndex={-1}>
        {selector}
      </Link>
    ) : (
      selector
    )
  }
)
